import 'core-js/es/object/from-entries';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { FirebaseProvider } from "./FirebaseContext";
import { SpeedInsights } from "@vercel/speed-insights/react"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SpeedInsights></SpeedInsights>
    <BrowserRouter>
      <FirebaseProvider>
          <App />
      </FirebaseProvider>
    </BrowserRouter>
  </React.StrictMode>
);

